'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M35.2 192l77.2 0c3.1-58.8 23.1-110.8 53.1-145.8C86.8 73.5 46.4 135.7 35.2 192zm109.2 0l223.1 0c-2.7-45.1-16.4-84.5-36-112.9C309.5 47.4 282.3 32 256 32s-53.5 15.4-75.5 47.1c-19.6 28.3-33.4 67.8-36 112.9zM192 368l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-32 0-32 0-32 0c-8.8 0-16 7.2-16 16zM346.5 46.2c29.9 35 50 87 53.1 145.8l77.2 0C465.6 135.7 425.2 73.5 346.5 46.2z', 'M256.1 0L256 0C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16l33.1 0L165 346.7c-3.2 6.4-5 13.7-5 21.3l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-7.7-1.8-14.9-5-21.3L462.9 224l33.1 0c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM418.9 224L324.1 324.4c-6.1-2.8-12.9-4.4-20.1-4.4l-32 0 0-96 95.5 0 32.1 0 19.3 0zM240 224l0 96-32 0c-7.2 0-14 1.6-20.1 4.4L93.1 224l19.3 0 32 0 95.5 0zm0 128l32 0 32 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l32 0zM35.2 192C46.4 135.7 86.8 73.5 165.5 46.2c-29.9 35-50 87-53.1 145.8l-77.2 0zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9l-223.1 0c2.7-45.1 16.4-84.5 36-112.9zM476.8 192l-77.2 0c-3.1-58.8-23.1-110.8-53.1-145.8C425.2 73.5 465.6 135.7 476.8 192z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;